import { useEffect, useState } from "react";
import styles from "./AnimationContainer.module.css";

export default function AnimationContainer({
    children,
    componentIndex = 0,
    processIndex,
}) {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (componentIndex !== processIndex) {
            setTimeout(() => {
                setIsActive(false);
            }, 490);
        } else {
            setTimeout(() => {
                setIsActive(true);
            }, 500);
        }
    }, [processIndex]);

    return (
        <>
            {isActive && (
                <div
                    className={`${styles.container} ${
                        styles[
                            componentIndex !== processIndex && `container-out`
                        ]
                    }`}
                >
                    {isActive && children}
                </div>
            )}
        </>
    );
}
